import { render, staticRenderFns } from "./ConfirmUserStage.vue?vue&type=template&id=3e0f0463&scoped=true&"
import script from "./ConfirmUserStage.vue?vue&type=script&lang=ts&"
export * from "./ConfirmUserStage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0f0463",
  null
  
)

export default component.exports